import { FC } from 'react';
// component
import ProfileComponent from 'components/main/Profile';

const Profile: FC = () => <ProfileComponent />;

export default Profile;
